// extracted by mini-css-extract-plugin
export default {"workpage":"Inout_workpage__EB-A+"};